module.exports = __webpack_public_path__ + "img/food_hotdog.86068b44.png";